export const TEST_ENVIRONMENTS = new Set([
    'localhost',
    'test.pilot.petsmart.com',
    'test.pilot.petsmart.ca',
    'staging.pilot.petsmart.com',
    'staging.pilot.petsmart.ca',
]);

const isEphemeralEnvironment = typeof process !== 'undefined' && !!process.env.NEXT_PUBLIC_EPHEMERAL;

export const isTestEnvironment = (hostname: string): boolean =>
    TEST_ENVIRONMENTS.has(hostname) || isEphemeralEnvironment;
